import React, { useState } from 'react';
import axios from 'axios';
import { getBaseUrl } from './ApiContext';
import './CompanyTimeline.css';

const baseUrl = getBaseUrl();

// The four Inactive reasons the spec names. Keys match the API's
// STATUS_LABEL in home/backend/company_timeline.py.
const INACTIVE_OPTIONS = [
    ['inactive_shutdown', 'Shut down'],
    ['inactive_acquired', 'Acquired'],
    ['inactive_founders_moved_on', 'Founders moved on'],
    ['inactive_other', 'Other'],
];

function shortDate(iso) {
    return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

// A status pill with a quiet "Change" link. The form only exists while it
// is open, on one line. A reason is required either way: the spec asks
// every status change to carry one.
function MonitoringStatus({ companyId, status, label, lastChecked, onChanged }) {
    const [open, setOpen] = useState(false);
    const [target, setTarget] = useState('inactive_shutdown');
    const [reason, setReason] = useState('');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    const active = !status || status === 'active';

    const close = () => { setOpen(false); setError(null); setReason(''); };

    const submit = async (event) => {
        event.preventDefault();
        setSaving(true);
        setError(null);
        try {
            const response = await axios.post(
                `${baseUrl}/api/companies/${companyId}/monitoring-status`,
                { status: active ? target : 'active', reason });
            close();
            onChanged(response.data);
        } catch (err) {
            setError(err.response?.data?.error || 'Could not change the status.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="ms">
            <div className="ms-row">
                <span className={`ms-state ${active ? 'is-active' : 'is-inactive'}`}>
                    <span className="ms-dot" />
                    {label || 'Active'}
                </span>
                <span className="ms-checked">
                    {lastChecked ? `last checked ${shortDate(lastChecked)}` : 'not checked yet'}
                </span>
                {!open && (
                    <button type="button" className="ms-link" onClick={() => setOpen(true)}>
                        {active ? 'Change' : 'Reactivate'}
                    </button>
                )}
            </div>
            {open && (
                <form className="ms-form" onSubmit={submit}>
                    {active && (
                        <select value={target} onChange={e => setTarget(e.target.value)}>
                            {INACTIVE_OPTIONS.map(([value, text]) => (
                                <option key={value} value={value}>{text}</option>
                            ))}
                        </select>
                    )}
                    <input
                        type="text"
                        placeholder={active ? 'Reason and source' : 'Why watch it again'}
                        value={reason}
                        onChange={e => setReason(e.target.value)}
                        maxLength={500}
                        autoFocus
                        required
                    />
                    <button type="submit" className="ms-save" disabled={saving || !reason.trim()}>
                        {saving ? 'Saving' : (active ? 'Mark inactive' : 'Reactivate')}
                    </button>
                    <button type="button" className="ms-link" onClick={close}>Cancel</button>
                    {error && <div className="ms-error">{error}</div>}
                </form>
            )}
        </div>
    );
}

export default MonitoringStatus;
